import './ourValuesSection.scss';

import labourGuaranteedImage from '../../images/icons/labour_guaranteed_icon.png';
import qualityWorkmanshipImage from '../../images/icons/quality_workmanship_icon.png';
import professionalServiceImage from '../../images/icons/professional_service_icon.png';

export const OurValuesSection = () => {
  const values: Array<{ name: string; icon: any; description: string }> = [
    {
      name: 'Quality Workmanship',
      icon: qualityWorkmanshipImage,
      description:
        'Our team is committed to providing the highest quality workmanship. We take pride in our attention to detail and dedication to delivering exceptional results for every project.',
    },
    {
      name: 'Labour Guaranteed',
      icon: labourGuaranteedImage,
      description:
        'We stand behind our work with a labour guarantee. Our customers can trust that our repairs and services are reliable and long-lasting, ensuring peace of mind.',
    },
    {
      name: 'Professional Service',
      icon: professionalServiceImage,
      description:
        'Our professionals are not only skilled but also courteous and respectful. We prioritize customer satisfaction by delivering services with the utmost professionalism and care.',
    },
  ];

  return (
    <div id={'our-values'} className={'our-values'}>
      <span id={'section-heading'}>Our Values</span>
      <div className={'our-values__top'}>
        <div className={'our-values__top__left'}>
          <h1>Repair Solutions for All Household Problems</h1>
        </div>
        <div className={'our-values__top__right'}>
          <p>
            We specialize in home repair and are dedicated to performing these jobs with proficiency and
            excellent results. Our core values drive our commitment to delivering exceptional service to our
            customers.
          </p>
        </div>
      </div>
      <div className={'our-values__bottom'}>
        {values.map(({ icon, description, name }, index) => (
          <div className={'our-values__bottom__item'} key={name + index}>
            <img src={icon} alt={name} />
            <span>{name}</span>
            <p>{description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
